import React, { useState } from 'react';
import ToolLayout from './layout/ToolLayout';
import Card, { CardHeader } from './ui/Card';
import Button from './ui/Button';
import CopyButton from './ui/CopyButton';
import FeedbackMessage from './ui/FeedbackMessage';
import FormField from './ui/FormField';

const PasswordGenerator = () => {
  const [passwords, setPasswords] = useState([]);
  const [length, setLength] = useState(12);
  const [includeUppercase, setIncludeUppercase] = useState(true);
  const [includeLowercase, setIncludeLowercase] = useState(true);
  const [includeNumbers, setIncludeNumbers] = useState(true);
  const [includeSpecialChars, setIncludeSpecialChars] = useState(true);
  const [passwordsAmount, setPasswordsAmount] = useState(3);
  const [feedback, setFeedback] = useState('');

  const generatePassword = () => {
    const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
    const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numberChars = '0123456789';
    const specialChars = '!@#$%^&*()_+[]{}|;:,.<>?';

    let validChars = '';
    if (includeUppercase) validChars += uppercaseChars;
    if (includeLowercase) validChars += lowercaseChars;
    if (includeNumbers) validChars += numberChars;
    if (includeSpecialChars) validChars += specialChars;

    if (!validChars) {
      setPasswords([]);
      setFeedback('Selecione pelo menos um conjunto de caracteres.');
      return;
    }

    const generateSinglePassword = () => {
      let newPassword = '';
      for (let i = 0; i < length; i += 1) {
        const randomIndex = Math.floor(Math.random() * validChars.length);
        newPassword += validChars[randomIndex];
      }
      return newPassword;
    };

    const generatedPasswords = Array.from({ length: passwordsAmount }, generateSinglePassword);
    setPasswords(generatedPasswords);
    setFeedback(`${generatedPasswords.length} senha(s) gerada(s) com sucesso.`);
  };

  return (
    <ToolLayout
      title="Password Generator"
      description="Gere senhas fortes com regras simples e um resultado pronto para copiar."
      category="Security & Identity"
      note="Sem backend, sem persistência"
    >
      <div className="tool-grid tool-grid--tool-page">
        <Card>
          <CardHeader title="Configuração" description="Defina o tamanho, volume e os grupos de caracteres." />
          <FormField label="Tamanho da senha">
            <input className="app-input" type="number" min="1" value={length} onChange={(e) => setLength(Math.max(1, parseInt(e.target.value, 10) || 1))} />
          </FormField>
          <FormField label="Quantidade de senhas">
            <input className="app-input" type="number" min="1" value={passwordsAmount} onChange={(e) => setPasswordsAmount(Math.max(1, parseInt(e.target.value, 10) || 1))} />
          </FormField>
          <div className="checkbox-grid">
            <label className="app-checkbox"><input type="checkbox" checked={includeUppercase} onChange={() => setIncludeUppercase(!includeUppercase)} /> <span>Maiúsculas</span></label>
            <label className="app-checkbox"><input type="checkbox" checked={includeLowercase} onChange={() => setIncludeLowercase(!includeLowercase)} /> <span>Minúsculas</span></label>
            <label className="app-checkbox"><input type="checkbox" checked={includeNumbers} onChange={() => setIncludeNumbers(!includeNumbers)} /> <span>Números</span></label>
            <label className="app-checkbox"><input type="checkbox" checked={includeSpecialChars} onChange={() => setIncludeSpecialChars(!includeSpecialChars)} /> <span>Especiais</span></label>
          </div>
          <div className="tool-actions">
            <Button onClick={generatePassword}>Gerar senhas</Button>
          </div>
          <FeedbackMessage type={passwords.length ? 'success' : 'error'}>{feedback}</FeedbackMessage>
        </Card>

        <Card>
          <CardHeader title="Resultado" description="Use uma ou várias saídas de uma vez." action={<CopyButton value={passwords.join('\n')} label="Copiar senhas" />} />
          <div className="output-panel">
            <span className="output-panel__label">Senhas geradas</span>
            <pre>{passwords.length ? passwords.join('\n') : 'As senhas geradas aparecerão aqui.'}</pre>
          </div>
        </Card>
      </div>
    </ToolLayout>
  );
};

export default PasswordGenerator;
